import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalVariableService } from '../../../services/configuration/global-variable.service';
import { WfTableComponent } from '../../../common/table-sort/wf-table.component';
import { GenericModalService } from '../../../services/generic-modal.service';
import { GlobalVariableGroupModalComponent } from './global-variable-group-modal/global-variable-group-modal.component';
import { BusinessProcessService } from '../../../services/business-process.service';

@Component({
  selector: 'app-global-variable-groups',
  templateUrl: './global-variable-groups.component.html',
  styleUrls: ['./global-variable-groups.component.css']
})
export class GlobalVariableGroupsComponent implements OnInit {

  errorMessage = '';
  pleaseWait = false;
  filteredGlobalVariableGroupList = [];
  globalVariableGroupList = [];
  hasRight: boolean;
  filterSettings = {
    placeholder: 'Filtrar',
    width: 100,
    inputTextSearchId: 'txtSearchGlobalVariable',
    showBooleanFilter: false,
    textFilterPropertyName: 'name',
  };
  modalComponent: any = GlobalVariableGroupModalComponent;
  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;

  constructor(
    private globalVariableService: GlobalVariableService,
    private modalService: GenericModalService,
    private businessProcessService: BusinessProcessService
  ) { }

  ngOnInit() {
    this.checkRights();
    this.getGlobalVariableGroupList();
  }

  getGlobalVariableGroupList() {
    this.errorMessage = '';
    this.pleaseWait = true;
    this.globalVariableService.getAllGlobalVariableGroups()
      .subscribe( list => {
        this.filteredGlobalVariableGroupList = list;
        this.globalVariableGroupList = list;
        this.pleaseWait = false;
      }, error1 => { this.errorMessage = error1; this.pleaseWait = false; });
  }

  onFilterList(filteredData: any[]) {
    this.filteredGlobalVariableGroupList = filteredData;
  }

  onAddNew() {
    if (this.hasRight) {
      const newGlobalVariableGroup = { };
      const result$ = this.modalService.showObjModal(this.modalComponent, 'Cadastrar grupo de variáveis globais', newGlobalVariableGroup);
      result$.asObservable()
        .subscribe(
          itemHasBeenSaved => {
            if (itemHasBeenSaved) { this.ngOnInit(); }
          }
        );
    } else {
      this.modalService.showErrorMessage('Usuário não tem direito a efetuar essa ação.', true);
    }
  }

  onEdit(globalVariableGroup: any) {
    if (this.hasRight) {
      const result$ = this.modalService.showObjModal(this.modalComponent, 'Editar grupo de variáveis globais', globalVariableGroup);
      result$.asObservable()
        .subscribe(
          itemHasBeenSaved => {
            if (itemHasBeenSaved) { this.ngOnInit(); }
          }
        );
    } else {
      this.modalService.showErrorMessage('Usuário não tem direito a efetuar essa ação.', true);
    }
  }

  onDelete(globalVariableGroup: any) {
    this.errorMessage = '';
    let alert: any;
    alert = this.modalService
      .showConfirmModal('Confirmação de Exclusão', 'Confirma a exclusão do grupo de variáveis globais?');
    alert.then( resp => {
      if (resp.value) {
        this.globalVariableService.removeGlobalVariableGroup(globalVariableGroup)
          .subscribe( () => {
              this.ngOnInit();
            },
            error1 => {
              this.modalService.showErrorMessage(error1, true);
            });
      }
    });
  }

  checkRights() {
    this.errorMessage = '';
    this.businessProcessService.checkRights(4194304)
      .subscribe( rights => {
        this.hasRight = rights.length > 0;
      }, error1 => {
        this.errorMessage = error1;
      });
  }

}
